import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

export const queryParams = {
  after: StringParam,
  before: StringParam,
  first: withDefault(NumberParam, 20),
  last: NumberParam,
  desc: withDefault(BooleanParam, true),
};
